/**
 * 对话框组件
 * @author  Jerry <jerry.hz.china@gmail.com>
 * @since   2025-03-27 11:51:47
 */
import { defineComponent } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useState, useMemo } from './doyo.useReactHooks.js';
// import { useLogger } from './doyo.useLogger.js';
import { isMobile } from './doyo.utils.js';

export default defineComponent({
  name: 'Dialog',
  template: `
		<Teleport to="body">
			<div class="dialog-container" :class="[$attrs.class, normalPCScreen ? 'pc' : 'mobile', mobileCenter ? 'mobile-center' : '']" v-show="visible">
				<div class="dialog-mask" @click="closeOnMask"></div>
				<div class="dialog">
					<div class="dialog-hd">
						<slot name="title"><div class="dialog-title">{{title}}</div></slot>
						<img :src="icn_close" class="icn icn-close" @click="close" />
					</div>
					<div class="dialog-bd" :class="[bodyNoPadding?'no-padding':'']">
						<slot />
					</div>
				</div>
			</div>
		</Teleport>
	`,
  props: {
    visible: { type: Boolean },
    title: { type: String },
    closeOnClickMask: { type: Boolean, default: false },
    bodyNoPadding: { type: Boolean, default: false },
    mobileCenter: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const [icn_close] = useState(GLOBAL_ICN_CLOSE);

    const close = () => {
      ctx.emit('close');
    };

    const closeOnMask = () => {
      if (props.closeOnClickMask) {
        close();
      }
    };

    const { width } = useWindowSize();

    const isPlatformMobile = useMemo(() => isMobile());

    const smallScreen = useMemo(() => width.value <= 1024);

    const normalPCScreen = useMemo(() => !smallScreen.value && !isPlatformMobile.value);

    return {
      icn_close,
      close,
      closeOnMask,
      windowWidth: width,
      isPlatformMobile,
      smallScreen,
      normalPCScreen,
    };
  },
});
